import React, { useEffect, useState } from 'react'
import logo from "../images/yg_logo_old.png"
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import dayjs from 'dayjs';
import timer from "../images/timer.gif"
import CustomSpinner from '../components/CustomSpinner';
function TakeActions({ serverURL }) {
    const [permissionData, setPermissionData] = useState(null)
    const [finalTimeLeft, setFinaTimeLeft] = useState(null)
    const [expired, setExpired] = useState(false)
    const [finalLoading, setFinalLoading] = useState(false)
    const [actedUser, setActedUser] = useState(null)
    const [serverMessage, setServerMessage] = useState(null)

    const authorities = [
        { "name": "Shivani", "email": "gulfan.nutron@gmail.com" },
        { "name": "Priya Mandal", "email": "fallenonyou@gmail.com" }
    ]

    let x;

    const getDetailsNow = async (idToWorkOn) => {
        const getDetailNow = await axios.post(serverURL + "/downloadhistory/findAction", { "uid": idToWorkOn })
        if (getDetailNow.status === 200) {
            setPermissionData(getDetailNow.data)
            console.log(getDetailNow.data)
            // let check = 86400 - Math.floor((dayjs().valueOf() - Math.floor(getDetailNow.data.time)) / 1000)
            let check = 86400 - Math.floor(dayjs().diff(parseInt(getDetailNow.data.time)) / 1000)


            if (check > 0) {
                x = setInterval(() => {
                    let totalTime = 86400 - Math.floor(dayjs().diff(parseInt(getDetailNow.data.time)) / 1000)
                    if (totalTime > 0) {
                        let hour = Math.floor(totalTime / 3600)
                        let restFromHour = totalTime % 3600
                        let minutes = Math.floor(restFromHour / 60)
                        let restFromMinutes = restFromHour % 60
                        let seconds = Math.floor(restFromMinutes)
                        setFinaTimeLeft(`${hour.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`)
                        setFinalLoading(true)
                    } else {
                        setExpired(true)
                        setFinaTimeLeft(0)
                        setFinalLoading(true);
                        clearInterval(x)
                    }
                }, 1000)
            } else {
                setFinaTimeLeft(0)
                setExpired(true)
                setFinalLoading(true);
            }
        } else {
            console.log(getDetailNow.data)
            setServerMessage(getDetailNow.data)
            setFinalLoading(true)
        }
    }

    const approveThisOne = async (uid) => {
        const query = {
            "uid": uid,
            "status": "approved",
            "updatedBy": authorities.filter((auth) => { return auth.email.includes(actedUser) })[0]
        }

        const doIt = await axios.post(serverURL + "/downloadhistory/updateState", query)
        if (doIt.status === 200) {
            console.log(doIt.data)
            clearInterval(x)
            setExpired(true)
            setServerMessage("Request Approved")
        } else {
            console.log(doIt.data)
        }
    }

    const rejectThisOne = async (uid) => {
        const query = {
            "uid": uid,
            "status": "rejected",
            "updatedBy": authorities.filter((auth) => { return auth.email.includes(actedUser) })[0]
        }

        const doIt = await axios.post(serverURL + "/downloadhistory/updateState", query)
        if (doIt.status === 200) {
            console.log(doIt.data)
            clearInterval(x)
            setExpired(true)
            setServerMessage("Request Rejected")
        } else {
            console.log(doIt.data)
        }
    }

    useEffect(() => {
        const linkData = window.location;
        const idToWorkOn = linkData.pathname.split("/")[2];
        setActedUser(linkData.pathname.split("/")[3])
        getDetailsNow(idToWorkOn)
    }, [])
    return (
        <>
            <div className='d-flex align-items-center justify-content-center vh-100 vw-100 p-4'>
                {
                    finalLoading ?
                        permissionData && expired === false ?
                            <div className='actionPanel p-4 d-flex flex-column align-items-center justify-content-start gap-3 w-100 overflow-hidden' >
                                <div className='d-flex flex-column justify-content-start align-items-center w-100'>
                                    <img src={logo} alt="" className='w-100 m-0' style={{ maxWidth: "100px" }} />
                                    <h1 className='w-100 text-center text-dark display-5' style={{ fontWeight: "400" }}>Need Action</h1>
                                </div>
                                <div className='d-flex gap-1 align-items-center'>
                                    <img src={timer} alt="" className='w-100' style={{ maxWidth: "3rem" }} />
                                    <p className='fs-4 m-0'>
                                        {
                                            finalTimeLeft
                                        }
                                    </p>
                                </div>
                                <div className='d-flex flex-column gap-1 w-100'>
                                    <table className='' cellPadding={3} cellSpacing={0}>
                                        <thead>
                                            <tr>
                                                <th colSpan={2} width="1%" >
                                                    <div style={{ fontSize: "1.2rem", fontWeight: "500", background: "rgba(255,255,255,0.2)" }} className='text-center p-1 mb-2' >
                                                        Request Details
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className='fw-bold'>From</td>
                                                <td>{permissionData.data.requestFrom}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-bold'>Time</td>
                                                <td>
                                                    {dayjs(parseInt(permissionData.time)).format("DD MMM YYYY, hh:mm:ssa")}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='fw-bold'>Data Requested</td>
                                                <td>{permissionData.data.requestName.label}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <hr />
                                </div>
                                <div className='d-flex gap-2 flex-wrap align-items-center justify-content-center w-100'>
                                    <button className='customButtons approveAction overflow-hidden' style={{ maxWidth: "200px" }} onClick={() => { approveThisOne(permissionData.uid) }}>Approve</button>
                                    <button className='customButtons rejectAction overflow-hidden' style={{ maxWidth: "200px" }} onClick={() => { rejectThisOne(permissionData.uid) }}>Reject</button>
                                </div>
                            </div>
                            :
                            <div className='actionPanel p-4 d-flex flex-column align-items-center justify-content-start gap-3 w-100 overflow-hidden' >
                                <span className='fs-4'>{serverMessage}</span>
                            </div>
                        :
                        <CustomSpinner size={1}/>

                }
            </div>
        </>
    )
}

export default TakeActions